import React from "react";

import "./Svg.scss";

interface SvgProps {
  svg: React.FunctionComponent;
  [key: string]: any;
}

export default React.forwardRef<React.ReactElement, SvgProps>(function Svg(props: SvgProps, ref) {
  const { svg, ...remainingProps } = { ...props };
  const SvgImage = svg;

  return (
    <SvgImage
      {...remainingProps}
      //@ts-ignore
      ref={ref}
    />
  );
});
